module.exports = __webpack_public_path__ + "static/media/4.5ceb0930.png";